import ListFilters from "@/common/components/ListFilters";
import TextField from "@/common/components/TextField";
import { useCities } from "@/common/hooks/queries/useCities";
import { useGeoStates } from "@/common/hooks/queries/useGeoStates";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { GeoTransformers } from "@/common/services/geoTransformers";
import { Mapper } from "@/common/services/mapper";
import { StateData } from "@/common/types/address";
import { SearchIcon } from "lucide-react";

interface EstablishmentMapFiltersProps {
  setSearch: (value: string) => void;
}

const EstablishmentMapFilters = ({ setSearch }: EstablishmentMapFiltersProps) => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [searchState, setSearchState] = useDebounce('');
  const [searchCity, setSearchCity] = useDebounce('');

  const { data: stateOptions } = useGeoStates({
    filters: { search: searchState },
    mapper: Mapper.mapToOptions<StateData>({ valueFieldName: "id", labelFieldName: "display_name" }),
  });

  const { data: cityOptions } = useCities({
    filters: {
      search: searchCity,
      stateId: filterParams.state?.value,
    },
    mapper: Mapper.mapWithTransformer({ transformer: GeoTransformers.optionsTransformer() }),
  });

  return (
    <div className='flex flex-col gap-4'>
      <div className="flex flex-row">
        <TextField
          LeftIcon={<SearchIcon />}
          placeholder="Pesquisar"
          className="rounded-md bg-map-search-100 shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5) w-full"
          onChange={(e) => {
            setSearch((e.target as HTMLInputElement).value);
            setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }));
          }}
          value={filterParams.search}
        />
      </div>

      <div className='me-7'>
        <ListFilters
          filters={[
            {
              className: 'w-1/2',
              placeholder: 'Estado',
              options: [{ label: 'Todas', value: '' }, ...stateOptions],
              value: filterParams.state || '',
              onChange: (e: any) => setFilterParams((prev) => ({ ...prev, state: e?.value ? e : null, city: null, })),
              onInputChange: setSearchState,
            },
            {
              className: 'w-1/2',
              placeholder: 'Cidade',
              options: [{ label: 'Todas', value: '' }, ...cityOptions],
              value: filterParams.city || '',
              onChange: (e: any) => setFilterParams((prev) => ({ ...prev, city: e?.value ? e : null })),
              onInputChange: setSearchCity,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default EstablishmentMapFilters;
